import React from 'react';
import { Search, SplitSquareHorizontal, CheckCircle2 } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Search,
    title: 'Search',
    desc: 'Find any game instantly from our database of 12,000+ titles.'
  }, {
    icon: SplitSquareHorizontal,
    title: 'Compare',
    desc: 'See critic vs user scores side by side to get the full picture.'
  }, {
    icon: CheckCircle2,
    title: 'Decide',
    desc: 'Make informed purchases. Never waste money on a bad port again.'
  }];
  return <section className="py-24 bg-pinnacle-dark relative" data-id="element-114">
      <div className="container mx-auto px-4" data-id="element-115">
        <div className="text-center mb-16" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-117">
            How Pinnacle Works
          </h2>
          <p className="text-gray-400" data-id="element-118">
            Three simple steps to your next favorite game.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 relative" data-id="element-119">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-20 right-20 h-0.5 bg-gradient-to-r from-transparent via-pinnacle-border to-transparent z-0" data-id="element-120"></div>

          {steps.map((step, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center max-w-xs" data-id="element-121">
              <div className="w-24 h-24 rounded-full bg-pinnacle-card border-4 border-pinnacle-dark shadow-[0_0_0_2px_#2a2a3e] flex items-center justify-center mb-6 group hover:scale-110 transition-transform duration-300" data-id="element-122">
                <step.icon className="w-10 h-10 text-pinnacle-green group-hover:text-pinnacle-cyan transition-colors" data-id="element-123" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-124">
                {step.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-125">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}